import { Guid } from "@/types"

export interface ICompanyDto {
    id: Guid
    name: string
}

export interface ICompany {
    id: Guid
    name: string
}

export default class Company implements ICompany {
    id: Guid
    name: string

    constructor({
        id,
        name
    }: ICompany) {
        this.id = id
        this.name = name
    }

    static fromDTO(dto: ICompanyDto): Company {
        return new Company({
            id: dto.id,
            name: dto.name,
        })
    }

    get nameAbbr(): string {
        const companyNameParts = this.name.split(" ") || []
        const abbrParts: string[] = []

        if (companyNameParts[0]) {
            abbrParts.push(companyNameParts[0][0].toUpperCase())
        }
        if (companyNameParts[1]) {
            abbrParts.push(companyNameParts[1][0].toUpperCase())
        }

        return abbrParts.join("")
    }
}
